import $ from 'jquery';
import {trackAddToCart} from "../components/analytics";

// Leave outside of document ready, needs to be global.
// Order Data
let productData = {
    productId: 0,
    type: '',
    material: '',
    addons: [],
    packaging: '',
    materialOption: '',
    labelPosition: '',
    childProductId: 0,
    quantity: 0,
    numberOfDesigns: 1,
    colour: '',

    // Getters/Setters
    getData() {
        return {
            productId: this.productId,
            type: this.type,
            material: this.material,
            addons: this.addons,
            packaging: this.packaging,
            materialOption: this.materialOption,
            labelPosition: this.labelPosition,
            childProductId: this.childProductId,
            quantity: this.quantity,
            colour: this.colour,
            numberOfDesigns: this.numberOfDesigns,
        };
    },
    setId(id) {
        this.productId = id;
    },
    setType(type) {
        this.type = type;
    },
    setColour(colour) {
        this.colour = colour;
    },
    setChildProduct(id) {
        this.childProductId = id;
    },
    setQuantity(quantity) {
        this.quantity = quantity;
    },
    setNumberOfDesigns(numberOfDesigns) {
        this.numberOfDesigns = numberOfDesigns;
    },
    setExtraColour(name, colour) {
        this.addons.push({ key: name, value: colour });
    },
    updateAddon(name, value) {
        this.addons.forEach((addon) => {
            if (addon.key === name) {
                addon.value = value;
            }
        });
    },

    // Functions

    // Updates a variation
    updateVariation($element, remove = false) {

        const self = this;

        // Is this a remove action?
        if (remove) {

            // Remove for addons are different to packaging
            if ($element.attr('data-addon') !== undefined) {
                const key = $element.attr('data-addon');
                const addonKey = self.addons.findIndex(item => item.key === key);
                self.addons.splice(addonKey, 1);
            } else {
                self.packaging = '';
            }

        } else {

            // Add data for add on
            // if ($element.attr('data-addon') !== undefined && $element.attr('data-id')) {
            if ($element.attr('data-addon') !== undefined) {

                // If the addon is already set, update instead of add
                const key = self.addons.findIndex(item => item.key === $element.attr('data-addon'));
                if (key !== -1) {

                    let value = null;

                    // Find the right value to use
                    if ($element.attr('data-id')) {
                        value = $element.attr('data-id');
                    } else if ($element.find('.switch__input').length > 0) {
                        value = $element.find('.switch__input').val();
                    } else {
                        value = $element.find('.js-extra-on').val();
                    }

                    self.addons[key].value = value;

                } else {
                    self.addons.push({
                        key: $element.attr('data-addon'),
                        value: $element.attr('data-id') ?? $element.find('.switch__input').val(),
                    });
                }

            } else {
                // Add data for packaging
                self.packaging = $element.attr('data-packaging');
            }

        }

        // Product data has changed, refresh the price
        updatePrice();

    },

    // Get all addons available on the page, for making sure data is correct in JS
    populateAddonData() {

        const self = this;

        let addons = [];
        const $elements = $('.js-addons-section .order-card--add-on');

        // Get an array of all addons required (unique values only)
        $elements.each((index, item) => {
            const addon = $(item).attr('data-addon');
            if (!addons.find(item => item.key === addon)) {
                addons.push({key: addon, value: null});
            }
        });

        // So now we know all the addons that have to be filled
        // If they're empty then we need to fill them with a default
        addons.forEach((item) => {
            // Addon hasn't been added to data, need to get default
            if (!self.addons.find(addon => addon.key === item.key)) {

                let value = 'none';
                const $element = $(`[data-addon="${item.key}"]`);

                // If non optional get current value, otherwise use default if present
                if ($element.attr('data-addon-default') ) {
                    value = $element.attr('data-addon-default');
                } else if (typeof $element.attr('data-non-optional') !== 'undefined') {
                    value = $element.find('.switch__input').val();
                }

                // Push to addons array
                self.addons.push({
                    key: item.key,
                    value: value,
                });

            }

        });

    },

    // Checks if addons have labels
    hasLabels() {
        return this.addons.find(addon => addon.key === 'pa_labels' && addon.value);
    },

};

$(function () {

    // Setup all events for the order system
    init();

    // Global order page events (events that don't need reinit)
    $('.slide-dots__dot').on('click', event => {

        const sectionSlug = $(event.currentTarget).attr('data-slide');
        const $section = $('.order-slide[data-slide="' + sectionSlug + '"]');

        $('.slide-dots__dot.active').removeClass('active');
        $(`.slide-dots__dot[data-slide="${sectionSlug}"]`).addClass('active');

        // Only allow scrolling to section if its been loaded
        if ($section.hasClass('active')) {
            window.scrollTo({
                top: $section.offset().top + 150,
                behavior: 'smooth'
            });
        }

    });

});

function reinitEvents() {

    // List of events to be destroyed
    const events = [
        {selector: '.js-select-product', event: 'click'},
        {selector: '.js-select-type', event: 'click'},
        {selector: '.js-select-material', event: 'click'},
        {selector: '.js-select-colour', event: 'click'},
        {selector: '.js-select-additional-colour', event: 'click'},
        {selector: '.js-select-addons', event: 'click'},
        {selector: '.qty-picker__plus', event: 'click'},
        {selector: '.qty-picker__minus', event: 'click'},
        {selector: '.js-switch .switch__wrapper', event: 'click'},
        {selector: '.js-select-addon-item', event: 'click'},
        {selector: '.js-select-modal-addon', event: 'click'},
    ];

    // Destroy events
    events.forEach(elem => {
        $(elem.selector).off(elem.event);
    });

    // Reinitialise
    init();

}

function panelLoading($elem) {
    const $parent = $elem.parents('.order-slide')
    $parent.addClass('panel-loading');
}

function panelStopLoading($elem) {
    const $parent = $elem.parents('.order-slide')
    $parent.removeClass('panel-loading');
}

// Initialise the order system
function init() {

    /* Next 'step' events */

    // Base product Set
    $('.js-select-product').on('click', event => {

        // Select the base product
        const $elem = $(event.currentTarget);
        productData.setId($elem.attr('data-id'));

        // Start animation
        panelLoading($elem);

        // Get the available types
        wpAjax('get_product_types', productData, 'POST')
            .then(data => {

                if (!data.skip_type) {
                    // Output product types and update title
                    $('.js-types-section').html(data.html);
                    $('.js-types-title').html(data.title);
                    scrollToNextSection($elem);
                } else {
                    // No product types found, jump to next section
                    $('.js-types-section').parent().hide();
                    $('.js-materials-section').html(data.html);
                    scrollToNextSection($elem, true);
                }

                // Clear and re-register events
                reinitEvents();

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Ajax call made to get product materials and output
    // Need to refactor as used by two event handlers.
    function getProductMaterials($elem = null) {
        // Get the materials
        wpAjax('get_product_materials', productData, 'POST')
            .then(data => {

                // Output product materials
                $('.js-materials-section').html(data.html);

                // Clear and re-register events
                reinitEvents();

                // Scroll to next section
                if ($elem !== null) {
                    scrollToNextSection($elem);
                }

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });
    }

    // Product type Set
    $('.js-select-type').on('click', event => {

        const $elem = $(event.currentTarget);

        // Start animation
        panelLoading($elem);

        // Get material and the correct product
        productData.setType($elem.attr('data-type'));
        getProductMaterials($elem);

    });

    function skipToQuantity(data, $elem) {

        // Jump to the quantity section skipping colours
        const $quantitySection = $(`.order-slide[data-slide="quantity"]`);
        $('.js-quantity-section').html(data.html);

        // Update the product total
        loadInitialProductTotal();

        // When quantity is loaded, show the price
        $('.order-total').addClass('active');

        // Clear and re-register events
        reinitEvents();

        // Scroll to next section
        scrollToNextSection($elem, true);

        // Stop loading
        panelStopLoading($quantitySection);

    }

    // Material Set
    $('.js-select-material').on('click', event => {

        // Get material and the correct product
        const $elem = $(event.currentTarget);
        productData.material = $elem.attr('data-material');

        // Start animation
        panelLoading($elem);

        // If the natural/bleached switch is present, add to data.
        if ($elem.find('.js-switch')) {
            productData.materialOption = $elem.find('.js-switch input[name="material"]').val();
        }

        // Get the product quantity select view
        wpAjax('get_product_colours', productData, 'POST')
            .then(data => {

                if (data.skip_type) {
                    productData.setChildProduct(data.child_product_id);
                    skipToQuantity(data, $elem);
                } else {
                    // Output quantity select
                    $('.js-colours-section').html(data.html);
                    $('.js-colours-label').text(data.title);

                    // Clear and re-register events
                    reinitEvents();

                    // Scroll to next section
                    scrollToNextSection($elem);

                    // Stop loading
                    panelStopLoading($elem);
                }

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Colour Set
    $('.js-select-colour').on('click', event => {

        // Get material and the correct product
        const $elem = $(event.currentTarget);
        productData.setColour($elem.attr('data-colour'));

        // Start animation
        panelLoading($elem);

        // Get the materials
        wpAjax('get_product_quantity_select', productData, 'POST')
            .then(data => {

                if (data.skip_to_extra_colour_section) {
                    renderExtraColourSection(data.html);
                } else {
                    // Output product materials
                    $('.js-quantity-section').html(data.html);
                    // Store child product ID
                    productData.setChildProduct(data.child_product_id);
                    // Update total
                    loadInitialProductTotal();
                }
                // Clear and re-register events
                reinitEvents();

                // Scroll to next section
                scrollToNextSection($elem);

                // When quantity is loaded, show the price
                $('.order-total').addClass('active');

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Generate an entire new section on the fly and slots it in between colour and quantity
    function renderExtraColourSection(html) {

        const $colourSection = $('.order-slide[data-slide="colour"]');
        $colourSection.after($colourSection.clone());

        const $extraColourSection = $colourSection.next();
        $extraColourSection.find('.js-colours-section').empty();
        $extraColourSection.find('.js-colours-section').html(html);
        $extraColourSection.find('.js-colours-section').addClass('js-extra-colours-section');
        $extraColourSection.find('.js-colours-section').removeClass('js-colours-section');

        $extraColourSection.removeClass('panel-loading');
        $extraColourSection.find('.order-slide__title').text('Select a colour')

    }

    // Colour Set
    $('.js-select-extra-colour').on('click', event => {

        // Get material and the correct product
        const $elem = $(event.currentTarget);
        productData.setExtraColour($elem.attr('data-name'), $elem.attr('data-colour'));

        // Start animation
        panelLoading($elem);

        // Get the materials
        wpAjax('get_product_quantity_select', productData, 'POST')
            .then(data => {

                // Output product materials
                $('.js-quantity-section').html(data.html);

                // Store child product ID
                productData.setChildProduct(data.child_product_id);

                // Update the product total
                loadInitialProductTotal();

                // Clear and re-register events
                reinitEvents();

                // Scroll to next section
                scrollToNextSection($elem);

                // When quantity is loaded, show the price
                $('.order-total').addClass('active');

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Quantity Set
    $('.js-select-quantity').on('click', event => {

        // Find quantity picker and get the quantity value
        const $elem = $(event.currentTarget).parents('.js-quantity-section');
        const quantity = $elem.find('.qty-picker__input input[name="qty"]').val();
        const numberOfDesigns = $elem.find('.qty-picker__input input[name="number_of_designs"]').val();
        productData.setQuantity(parseInt(quantity));
        productData.setNumberOfDesigns(parseInt(numberOfDesigns));

        // Start animation
        panelLoading($elem);

        // Get the product quantity select view
        wpAjax('get_product_addons', productData, 'POST')
            .then(data => {

                // Output quantity select
                $('.js-addons-section').html(data.html);

                // Clear and re-register events
                reinitEvents();

                // Scroll to next section
                scrollToNextSection($elem);

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Addons Set
    $('.js-select-addons').on('click', event => {

        const $elem = $(event.currentTarget);

        // If no labels are present, we cannot proceed
        // if (!hasLabelsSelected()) {
        //     displayErrorMessage('Please select some labels for this product.');
        //     return;
        // }

        // Start animation
        panelLoading($elem);

        // Populate addon date before sending
        productData.populateAddonData();

        // Find and Set label position too
        const selectedLabel = productData.addons.find(item => item.key === 'pa_labels');
        const $selectedCard = $(`.order-card[data-id='${selectedLabel.value}'] .js-switch input[name="labelPosition"]`);
        if ($selectedCard) {
            productData.labelPosition = $selectedCard.val();
        }

        wpAjax('get_product_packaging', productData, 'POST')
            .then(data => {

                // Output quantity select
                $('.js-packaging-section').html(data.html);

                // Clear and re-register events
                reinitEvents();

                // Scroll to next section
                scrollToNextSection($elem);

                // Stop loading
                panelStopLoading($elem);

            })
            .catch(error => {
                console.error(error);
            });

    });

    // Packaging Set
    $('.js-select-packaging').on('click', (event) => {

        // Start animation
        panelLoading($(event.currentTarget));

        if (!productData.packaging) {
            displayErrorMessage('Please select a packaging option for this product.');
            panelStopLoading($(event.currentTarget));
        } else {
            // Get the product quantity select view
            wpAjax('add_completed_product_to_cart', productData, 'POST')
                .then(data => {
                    if (data.status === 'success') {
                        $('body').addClass('no-scroll');
                        $('.js-complete-message').text(data.message);
                        $('.js-complete-total').html(data.item_total);
                        $('.js-complete-section').addClass('active');
                        $('.js-order-continue').attr('href', `/cart/?sample-check=true&productKey=${data.item_key}`);
                        panelStopLoading($(event.currentTarget));
                        trackAddToCart(data.item_total_value, data.extra_data);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    });

    /* UI Component events */

    // Quantity pickers (plus and minus inputs)
    window.qtyPickerTimeout = null;
    $('.qty-picker').each((index, item) => {

        // Get control properties
        const $input = $(item).find('input');
        const isQuantity = $input.attr('name') === 'qty';
        const increment = parseInt($input.attr('data-increment'));
        const minQty = parseInt($input.attr('min'));

        // Set initial max value for units per design
        if (!isQuantity) {
            const currentQuantity = parseInt($('input[name="qty"]').val());
            updateNumberOfDesigns(currentQuantity);
        }

        // Quantity picker button event handler
        $(item).find('.qty-picker__btn').on('click', function() {

            // Get input value
            let currentValue = parseInt($input.val());

            // If has class minus
            if ($(this).hasClass('qty-picker__plus')) {
                if (isQuantity) {
                    $input.val(currentValue + increment);
                    updateNumberOfDesigns(currentValue + increment);
                    productData.setQuantity(currentValue + increment);
                } else {
                    const maxQty = parseInt($input.attr('max'));
                    if (currentValue < maxQty) {
                        $input.val(currentValue + increment);
                    }
                }
            } else if ($(this).hasClass('qty-picker__minus')) {
                if ((currentValue - increment) >= minQty) {
                    $input.val(currentValue - increment);
                    if (isQuantity) {
                        updateNumberOfDesigns(currentValue - increment);
                        productData.setQuantity(currentValue - increment);
                    }
                }
            }

            // Only run if this is a quantity picker, not number of designs

            // Fade total before timeout
            if (isQuantity) {
                $('.order-total__price').css('opacity', '0.3');
                clearTimeout(window.qtyPickerTimeout);
                window.qtyPickerTimeout = setTimeout(() => {
                    wpAjax('get_product_price', productData, 'POST').then(response => {
                        $('.order-total__price').html(response.price);
                        $('.order-total__price').css('opacity', '1');
                    });
                }, 2000);
            }

        });



    });

    // UI Switches
    $('.js-switch .switch__wrapper').on('click', event => {

        // Stop this triggering the 'select material' event
        event.stopPropagation();

        // Store the target element
        const $self = $(event.currentTarget);

        // Elements
        const $active = $self.siblings('.switch__label.active');
        const $inactive = $self.siblings('.switch__label:not(.active)');
        const $input = $self.children('.switch__input');
        const $parent = $self.parents('.order-card--add-on');

        // Update classes
        $self.toggleClass('active');
        $inactive.addClass('active');
        $active.removeClass('active');

        // Update values
        $input.val($inactive.attr('data-value'));

        // Update price (only addons have a price so we'll update those too)
        if ($inactive.attr('data-price')) {

            // Update price on element
            const price = $inactive.attr('data-price') === '' ? `+ £0.00` : `+ £${$inactive.attr('data-price')}`;
            $input.parents('.order-card').find('.order-card__price').text(price);

            // Update addons and pricing total of addon has already been selected
            const $parent = $self.parents('.order-card--add-on');
            if ($parent.find('.js-select-addon-item.active').length > 0) {
                productData.updateVariation($parent);
            }
        } else if (typeof $parent.attr('data-non-optional') !== undefined) {
            productData.updateAddon($parent.attr('data-addon'), $input.val());
        }

    });

    // Select addon or packging options
    $('.js-select-addon-item').on('click', event => {

        const $self = $(event.currentTarget);
        const $parent = $self.parents('.order-card--add-on');

        /**
         * If active
         *  -> Remove active class and change text
         * If not active
         *  -> If part of a group, deactivate currently active class from group
         *  -> Otherwise, just add active class
         */

        if ($self.hasClass('active')) {

            // Update Button
            $self.removeClass('active');
            $self.find('.order-card__add-label').text('Add');

            // Remove from product data
            productData.updateVariation($parent, true);

        } else {

            // If parent of an addon group, remove the currently active item
            const $activeFromSameGroup = $(`[data-addon="${$parent.attr('data-addon')}"] .js-select-addon-item.active`);
            const $activePackagingGroup = $(`[data-packaging] .js-select-addon-item.active`);

            if ($activeFromSameGroup && $parent.attr('data-id')) {
                $activeFromSameGroup.find('.order-card__add-label').text('Add');
                $activeFromSameGroup.removeClass('active');
            } else if ($activePackagingGroup && $parent.attr('data-packaging')) {
                $activePackagingGroup.find('.order-card__add-label').text('Add');
                $activePackagingGroup.removeClass('active');
            }

            // Update Button
            $self.addClass('active');
            $self.find('.order-card__add-label').text('Remove');

            // Update Data
            productData.updateVariation($parent);

        }

    });

    // Back arrows
    $('.js-slide-back').on('click', event => {

        // Find previous section
        const $slide = $(event.currentTarget).parents('.order-slide');
        const offset = 100;

        // Animate out current element
        $slide.removeClass('active');

        // Change order step dots
        if ($slide.attr('data-slide') !== undefined) {
            const $activeDot = $('.slide-dots__dot[data-slide="' + $slide.attr('data-slide') + '"]');
            $activeDot.removeClass('active');
            $activeDot.prev().addClass('active');
        }

        // Scroll to previous item
        window.scrollTo({
            top: $slide.prev().offset().top - offset,
            behavior: 'smooth'
        });

    });

    // Closes an open order notice
    $('.js-order-notice .order-notice__close').on('click', () => {
        $('.js-order-notice').removeClass('active');
        $('.js-order-notice .order-notice__msg').text('');
        clearTimeout(window.orderNoticeTimeout);
    });

    // Open addons modal
    $('.js-open-addon-modal').on('click', function() {

        // Grab data
        const data = {
            addonName: $(this).parents('.order-card--add-on').attr('data-addon'),
            childProductId: productData.childProductId,
        };

        // Fetch modal content if not already loaded
        if ($('.js-addon-option-modal').attr('data-loaded') !== data.addonName) {
            wpAjax('get_attribute_values', data)
                .then(response => {
                    $(`.js-addon-option-modal`).addClass('active');
                    $('.addons-overlay').addClass('active');
                    $('.js-addon-option-modal .modal__content').html(response.html);
                    $('.js-addon-option-modal').attr('data-loaded', data.addonName);
                    reinitEvents();
                })
                .catch(error => {
                    console.error(error);
                });
        } else {
            $(`.js-addon-option-modal`).addClass('active');
            $('.addons-overlay').addClass('active');
        }

    });

    // Close addons modal
    $('.js-addon-modal-close').on('click', function() {
        $(`.js-addon-option-modal`).removeClass('active');
        $('.addons-overlay').removeClass('active');
    });

    // Select addon in modal
    $('.js-select-modal-addon').on('click', function() {

        const $self = $(this);
        const $parent = $self.parents('.order-card--add-on');

        // Add addon to productData
        if ($self.hasClass('active')) {

            // Update Button
            $self.removeClass('active');
            $self.find('.order-card__add-label').text('Add');

            // Remove from product data
            productData.updateVariation($parent, true);

            // Update selected addon values
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__option`).text('');
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__price`).html('+ £0.00');

            // Update active state of actual card
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__add`).removeClass('active');
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__add-label`).text('Add');

        } else {

            // If parent of an addon group, remove the currently active item
            const $activeFromSameGroup = $(`.modal-items-grid [data-addon="${$parent.attr('data-addon')}"] .js-select-modal-addon.active`);
            if ($activeFromSameGroup && $parent.attr('data-id')) {
                $activeFromSameGroup.find('.order-card__add-label').text('Add');
                $activeFromSameGroup.removeClass('active');
            }

            // Update Button
            $self.addClass('active');
            $self.find('.order-card__add-label').text('Remove');

            // Update Data
            productData.updateVariation($parent);

            // Show chosen addon in card
            const name = $self.siblings('.order-card__title').text();
            const price = $self.siblings('.order-card__price').html();
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__option`).text('Selected: ' + name);
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__price`).html(price);

            // Update active state of actual card
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__add`).addClass('active');
            $(`.cards-grid [data-addon="${$parent.attr('data-addon')}"] .order-card__add-label`).text('Edit');

        }

        // Close modal
        $(`.js-addon-option-modal`).removeClass('active');
        $('.addons-overlay').removeClass('active');

    });

}

// Simple promise based wrapper function to make AJAX calls to WP.
function wpAjax(action, productData, method = 'GET') {
    return new Promise((resolve, reject) => {

        // Get data from object if method is available
        let data = productData;
        if (typeof data.getData === 'function') {
            data = productData.getData();
        }

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: method,
            data: {
                action: action,
                ...data,
            },
            complete: (response) => {
                resolve(response);
            },
            error: (error) => {
                reject(error);
            }
        })
    });
}

// Handles the animate in and scroll to of the next section
function scrollToNextSection($currentElem, skipToNext = false) {

    // Find parent, get index, add one and scrollTo next in list then fade in
    const $parent = $currentElem.parents('.order-slide');
    let $nextSlide = $parent.next('.order-slide');

    if (skipToNext) {
        $nextSlide = $nextSlide.next('.order-slide')
    }

    $nextSlide.css('display', 'grid');
    setTimeout(() => {
        $nextSlide.addClass('active');
    }, 100);

    // Update active state of aside dots
    if ($nextSlide.attr('data-slide') !== undefined) {
        $('.slide-dots__dot').removeClass('active');
        $(`.slide-dots__dot[data-slide="${$nextSlide.attr('data-slide')}"]`).addClass('active');
    }

    // Scroll to offset
    let offset = 200;
    if (window.matchMedia('(max-width: 41rem)').matches) {
        offset = 125;
    }

    // Scroll to next section
    window.scrollTo({
        top: $nextSlide.offset().top - offset,
        behavior: 'smooth'
    });

}

// Update the total in the bottom corner
function updatePrice() {

    // Fade price out while updating
    $('.order-total__price').css('opacity', '0.3');

    // Make sure we have all addons setup with defaults
    productData.populateAddonData();

    // Update price via ajax and fade in
    wpAjax('get_product_price', productData, 'POST').then(response => {
        $('.order-total__price').html(response.price);
        $('.order-total__price').css('opacity', '1');
    });

}

// Displays an error message in a popup with a timeout
function displayErrorMessage(message, colour) {

    $('.js-order-notice .order-notice__msg').text(message);
    $('.js-order-notice').addClass(`active order-notice--${colour}`);

    window.orderNoticeTimeout = setTimeout(() => {
        $('.js-order-notice').removeClass('active');
        $('.js-order-notice .order-notice__msg').text('');
    }, 10300);

}

// Updates the number of designs applicable based on quantity
function updateNumberOfDesigns(quantity) {

    const $itemsPerDesignElem = $('.js-items-per-design');
    const unitsPerDesign = parseInt($itemsPerDesignElem.attr('data-per-design'));

    // Quantity / unitsper design, floor then set as max
    const max = Math.floor(quantity / unitsPerDesign);
    $itemsPerDesignElem.attr('max', max);

    // Check current number of designs is still valid
    const currentNumberOfDesigns = parseInt($itemsPerDesignElem.val());
    if (currentNumberOfDesigns > max) {
        $itemsPerDesignElem.val(max);
    }

}

// Checks if a user has selected any labels
function hasLabelsSelected() {

    const $labelCards = $('.order-card--add-on[data-addon="pa_labels"]');

    let selected = false;
    $labelCards.each(function() {
        if ($(this).find('.order-card__add').hasClass('active')) {
            selected = true;
        }
    });

    return selected;

}

// Grabs the initial price when the quantity section is loaded
function loadInitialProductTotal() {

    // Grab initial quantity from new section
    const quantity = $('.qty-picker input[name="qty"]').val();
    productData.setQuantity(quantity);

    // Update prices
    wpAjax('get_product_price', productData, 'POST').then(response => {
        $('.order-total__price').html(response.price);
        $('.order-total__price').css('opacity', '1');
    });

}
